import { BOX_COLORS, BOX_TYPES } from '../utils/products.enums'
import { Size } from '../utils/Size'
import { PRODUCTS_LIST } from '../utils/products.list'
import { PrintingSettings } from '../utils/PrintingSettings'

export default class AmericanBoxFormModel {
  name = PRODUCTS_LIST.AMERICAN_BOX;

  constructor () {
    this.size = new Size()
    this.externalSize = 'external'
    this.color = BOX_COLORS.WHITE
    this.boxType = BOX_TYPES.ONE_WAVE
    this.printing = new PrintingSettings()
    this.amount = null
    this.alveolar = true
    this.additionalNotes = null
    this.email = null
  }
}
